import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/services/data.service';
import * as _ from 'lodash';
import { InstituteInfo } from '../../pages/app.config';
import { InputformatService } from "src/app/services/inputformat.service";
import { LaptopSavepopupComponent } from '../laptop-savepopup/laptop-savepopup.component';
import { fail } from 'assert';


@Component({
  selector: 'app-laptopscheme-data',
  templateUrl: './laptopscheme-data.component.html',
  styleUrls: ['./laptopscheme-data.component.scss']
})
export class LaptopschemeDataComponent implements OnInit {

  studentForm!: FormGroup;
  submitted: boolean = false;

  // universityList = ['Anna University', 'VTU', 'JNTU'];
  instituteList = ['Sona College of Engineering', 'PSG', 'SRM'];
  academicYears = ['2020 - 2021', '2021 - 2022', '2022 - 2023'];
  streamList = ['Engineering and Technology', 'Arts', 'Science'];
  mediumList = ['English', 'Tamil'];
  courseTypes = ['UG', 'PG'];
  states = ['Tamil Nadu', 'Karnataka', 'Kerala'];
  districts = ['Chennai', 'Salem', 'Coimbatore'];
  universityList: any[];
  courseCategoryLsit: any[];
  courseList: any[];
  ModeofStudyList: any[];
  ShiftList: any[];
  genderList = [
    { key: 1, value: 'Male' },
    { key: 2, value: 'Female' },
    { key: 3, value: 'Third Gender' }
  ];
  BranchSpecializationList: any[];
  showInput: any = true;
  statesList: any[];
  districtsList: any[];
  nationalityList = [
    { key: 1, value: 'Indian' },
    // { key: 2, value: 'Other' }
  ];
  maxDob: string;
  minDob: string;
  minDob1: string;
  maxDob1: string;
  showOtppopup: boolean = false;


  constructor(private fb: FormBuilder,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<LaptopschemeDataComponent>,
    private toaster: ToastrService,
    private dataService: DataService,
    private inputFormatService: InputformatService,


  ) { }

  ngOnInit() {
    // Validators.emailValidators.required, Validators.pattern(/^[a-zA-Z. ]*$/)
    this.studentForm = this.fb.group({
      universityName: [''],
      instituteName: [''],
      others: [false],
      otherUniversity: [''],
      otherInstitute: [''],
      academicYear: ['', Validators.required],
      stream: ['', Validators.required],
      courseType: ['', Validators.required],
      CourseCategory: ['', Validators.required],
      Course: ['', Validators.required],
      ModeofStudy: ['', Validators.required],
      Shift: ['', Validators.required],
      medium: ['', Validators.required],
      name: ['', Validators.required],   // only letters, dot, space],
      motherName: ['', Validators.required],   // only letters, dot, space],
      fatherName: ['', Validators.required],   // only letters, dot, space],
      email: ['', [Validators.required, Validators.email]],
      gender: ['', Validators.required],
      BranchSpecialization: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      state: ['', Validators.required],
      district: ['', Validators.required],
      nationality: [null, Validators.required],
      dob: [null, Validators.required],
      DateofAdmission: [null, Validators.required],

    });
    this.universitylookup();
    this.academicYear();
    this.stateNamelookup();
    this.toggleOthers();
    this.datevalidtionFunc();
    this.datevalidtionFunc1();
  }

  datevalidtionFunc() {
    const today = new Date();

    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    // this.minDob = "2016-01-01";
    this.maxDob = "2015-01-01"
    // `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;

      
  }

  datevalidtionFunc1() {
    const today = new Date();
    const minAge = 15;

    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    this.minDob1 = "2019-01-01";
    this.maxDob1 = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;

      
  }

  onlyNum(event: KeyboardEvent) {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  toggleOthers() {
    debugger
    const others = this.studentForm.get('others')?.value;
    if (others) {
      this.showInput = false;
      // Disable dropdown validators
      this.studentForm.get('universityName')?.clearValidators();
      this.studentForm.get('instituteName')?.clearValidators();
      this.studentForm.get('universityName')?.updateValueAndValidity();
      this.studentForm.get('instituteName')?.updateValueAndValidity();

      // Enable text field validators
      this.studentForm.get('otherUniversity')?.setValidators([Validators.required]);
      this.studentForm.get('otherInstitute')?.setValidators([Validators.required]);
      this.studentForm.get('otherUniversity')?.updateValueAndValidity();
      this.studentForm.get('otherInstitute')?.updateValueAndValidity();
      this.studentForm.get('universityName').setValue(null);
      this.studentForm.get('instituteName').setValue(null);
      localStorage.setItem('flag', '1'); 

      this.streamlookup();

    } else {
      // Enable dropdown validators
      this.showInput = true;

      this.studentForm.get('universityName')?.setValidators([Validators.required]);
      this.studentForm.get('instituteName')?.setValidators([Validators.required]);
      this.studentForm.get('universityName')?.updateValueAndValidity();
      this.studentForm.get('instituteName')?.updateValueAndValidity();

      // Disable text field validators
      this.studentForm.get('otherUniversity')?.clearValidators();
      this.studentForm.get('otherInstitute')?.clearValidators();
      this.studentForm.get('otherUniversity')?.updateValueAndValidity();
      this.studentForm.get('otherInstitute')?.updateValueAndValidity();
      this.studentForm.get('universityName').setValue(null);
      this.studentForm.get('instituteName').setValue(null);
        localStorage.setItem('flag', '0');

      this.streamlookup();

    }
  }

  universitylookup() {
    this.dataService.getuniversity(true).subscribe(res => {
      if (res) {
        this.universityList = [];
        this.universityList = _.orderBy(res, ["value"], ["asc"]);
      }
    });
  }
  InstitutelookUp() {
    this.dataService.getInstitutelookup(this.studentForm.get('universityName').value, true).subscribe(res => {
      if (res) {
        this.instituteList = [];
        this.instituteList = _.orderBy(res, ["value"], ["asc"]);
      }
    });
  }


  streamlookup() {
    const others = this.studentForm.get('others')?.value;
    if (others) {
      this.dataService.getStreamlist(true).subscribe(res => {
        if (res) {
          this.streamList = [];
          this.streamList = _.orderBy(res, ["value"], ["asc"]);
        }
      });
    }
    else {
      if (this.studentForm.get('instituteName').value) {
        this.dataService.getStreamlistlookup(this.studentForm.get('instituteName').value, true).subscribe(res => {
          if (res) {
            this.streamList = [];
            this.streamList = _.orderBy(res, ["value"], ["asc"]);
          }
        });
      }


    }

  }

  courselookup() {
    if (this.studentForm.get('stream').value) {
      const instituteId = this.studentForm.get('instituteName').value ? this.studentForm.get('instituteName').value : 0;
      const others = this.studentForm.get('others')?.value ? true : false;
      this.dataService.getcourselookUp(this.studentForm.get('stream').value, instituteId, others, true).subscribe(res => {
        if (res) {
          let courseType = _.orderBy(res, ["value"], ["asc"]);
          this.courseTypes = courseType.filter(x =>
          Number(x.key) == 3 || Number(x.key) == 2 ||Number(x.key) == 6
        );
        }
      });
    }

  }
  courseCategory() {
    if (this.studentForm.get('courseType').value) {
      const instituteId = this.studentForm.get('instituteName').value ? this.studentForm.get('instituteName').value : 0;
      const others = this.studentForm.get('others')?.value;
      this.dataService.getcoursecategorylookUp(this.studentForm.get('stream').value, this.studentForm.get('courseType').value, instituteId, others, true).subscribe(res => {
        if (res) {
          this.courseCategoryLsit = [];
          this.courseCategoryLsit = _.orderBy(res, ["value"], ["asc"]);
        }
      });
    }

  }

  academicYear() {
    this.dataService.getacademicYear(true).subscribe(res => {
      if (res) {
        let year = _.orderBy(res, ["value"], ["desc"]);
        this.academicYears = year.filter(x =>
          Number(x.key) >= 221 && Number(x.key) <= 227
        );
        console.log(this.academicYears, "academicYears")
      }
    });
  }


  course() {
    if (this.studentForm.get('CourseCategory').value) {
      const others = this.studentForm.get('others')?.value;
      const id = this.studentForm.get('instituteName').value != null ? this.studentForm.get('instituteName').value : 0;
      this.dataService.getcourseoflookUp(id, this.studentForm.get('stream').value, this.studentForm.get('courseType').value, this.studentForm.get('CourseCategory').value, others, true).subscribe(res => {
        if (res) {
          this.courseList = [];
          this.courseList = _.orderBy(res, ["value"], ["asc"]);
        }
      });
    }

  }

  modeofstudylookup() {
    if (this.studentForm.get('Course').value) {
      const instituteId = this.studentForm.get('instituteName').value ? this.studentForm.get('instituteName').value : 0;
      const others = this.studentForm.get('others')?.value;
      this.dataService.getmodestudyUp(this.studentForm.get('Course').value, instituteId, others, true).subscribe(res => {
        if (res) {
          this.ModeofStudyList = [];
          this.ModeofStudyList = _.orderBy(res, ["value"], ["asc"]);
        }
      });
    }

  }

  Shiftlookup() {
    if (this.studentForm.get('ModeofStudy').value) {
      const instituteId = this.studentForm.get('instituteName').value ? this.studentForm.get('instituteName').value : 0;
      const others = this.studentForm.get('others')?.value;
      this.dataService.shiftlookup(this.studentForm.get('Course').value, this.studentForm.get('ModeofStudy').value, instituteId, others, true).subscribe(res => {
        if (res) {
          this.ShiftList = [];
          this.ShiftList = _.orderBy(res, ["value"], ["asc"]);
        }
      });
    }

  }

  mediumlookup() {
    if (this.studentForm.get('Shift').value) {
      const instituteId = this.studentForm.get('instituteName').value ? this.studentForm.get('instituteName').value : 0;
      const others = this.studentForm.get('others')?.value;
      this.dataService.mediumlookup(this.studentForm.get('Course').value, this.studentForm.get('ModeofStudy').value, this.studentForm.get('Shift').value, instituteId, others, true).subscribe(res => {
        if (res) {
          this.mediumList = [];
          this.mediumList = _.orderBy(res, ["value"], ["asc"]);
        }
      });
    }

  }

  Branchlookup() {
    if (this.studentForm.get('medium').value) {
      const instituteId = this.studentForm.get('instituteName').value ? this.studentForm.get('instituteName').value : 0;
      const others = this.studentForm.get('others')?.value;
      this.dataService.Branchlookup(this.studentForm.get('Course').value, this.studentForm.get('ModeofStudy').value, this.studentForm.get('Shift').value, this.studentForm.get('medium').value, instituteId, others, true).subscribe(res => {
        if (res) {
          this.BranchSpecializationList = [];
          this.BranchSpecializationList = _.orderBy(res, ["value"], ["asc"]);
        }
      });
    }

  }

  stateNamelookup() {
    this.dataService.stateNamelookup(true).subscribe(res => {
      if (res) {
        this.statesList = [];
        this.statesList = _.orderBy(
          res.filter(x => Number(x.key) === 1),
          ["value"],
          ["asc"]
        );

      }
    });
  }

  districtNamelookup() {
    this.dataService.districtNamelookup(this.studentForm.get('state').value, true).subscribe(res => {
      if (res) {
        this.districtsList = [];
        this.districtsList = _.orderBy(res, ["value"], ["asc"]);
      }
    });
  }

  
  onUnversityChange(value) {
    this.InstitutelookUp();
     this.studentForm.get('instituteName').setValue(null);
     this.studentForm.get('stream').setValue(null);
     this.studentForm.get('courseType').setValue(null);
    this.studentForm.get('CourseCategory').setValue(null);
    this.studentForm.get('Course').setValue(null);
    this.studentForm.get('ModeofStudy').setValue(null);
    this.studentForm.get('Shift').setValue(null);
    this.studentForm.get('medium').setValue(null);
    this.studentForm.get('BranchSpecialization').setValue(null);

  }
  oninstitueChange(value) {
    this.streamlookup();
     this.studentForm.get('courseType').setValue(null);
    this.studentForm.get('CourseCategory').setValue(null);
    this.studentForm.get('Course').setValue(null);
    this.studentForm.get('ModeofStudy').setValue(null);
    this.studentForm.get('Shift').setValue(null);
    this.studentForm.get('medium').setValue(null);
    this.studentForm.get('BranchSpecialization').setValue(null);

  }

  onStreamChange(value) {
    this.courselookup();
    this.studentForm.get('courseType').setValue(null);
    this.studentForm.get('CourseCategory').setValue(null);
    this.studentForm.get('Course').setValue(null);
    this.studentForm.get('ModeofStudy').setValue(null);
    this.studentForm.get('Shift').setValue(null);
    this.studentForm.get('medium').setValue(null);
    this.studentForm.get('BranchSpecialization').setValue(null);

  }
  
  oncourseTypeChange(value) {
    this.courseCategory();
    this.studentForm.get('CourseCategory').setValue(null);
    this.studentForm.get('Course').setValue(null);
    this.studentForm.get('ModeofStudy').setValue(null);
    this.studentForm.get('Shift').setValue(null);
    this.studentForm.get('medium').setValue(null);
    this.studentForm.get('BranchSpecialization').setValue(null);

  }

  onCoursecategory(value) {
    this.course();
    this.studentForm.get('Course').setValue(null);
    this.studentForm.get('ModeofStudy').setValue(null);
    this.studentForm.get('Shift').setValue(null);
    this.studentForm.get('medium').setValue(null);
    this.studentForm.get('BranchSpecialization').setValue(null);

  }
  onCourse(value) {
    this.modeofstudylookup();
    this.studentForm.get('ModeofStudy').setValue(null);
    this.studentForm.get('Shift').setValue(null);
    this.studentForm.get('medium').setValue(null);
    this.studentForm.get('BranchSpecialization').setValue(null);

  }
  onmodeOfstudy(value) {
    this.Shiftlookup();
    this.studentForm.get('Shift').setValue(null);
    this.studentForm.get('medium').setValue(null);
    this.studentForm.get('BranchSpecialization').setValue(null);

  }

  onShift(value) {
    this.mediumlookup();
    this.studentForm.get('medium').setValue(null);
    this.studentForm.get('BranchSpecialization').setValue(null);

  }
  onmedium(value) {
    this.Branchlookup();
    this.studentForm.get('BranchSpecialization').setValue(null);

  }
  onStatechange() {
    this.districtNamelookup();
    this.studentForm.get('district').setValue(null);

  }


  closeAadharPopup() {
    // this.closePopup.emit(true);
    this.dialogRef.close(false);

  }

  sendData() {
    if (this.studentForm.valid) {
      this.submitted = false;
      this.showOtppopup = true;
      let aadhaarNo = localStorage.getItem("studentForm");
      aadhaarNo = aadhaarNo.trim().replace(/\s+/g, '').replace(/\D/g, '');
      const aadhaarNumberOnly = Number(aadhaarNo);

      let payload = {
        "universityName": this.studentForm.get('otherUniversity').value != null ? this.studentForm.get('otherUniversity').value : null,
        "instituteName": this.studentForm.get('otherInstitute').value != null ? this.studentForm.get('otherInstitute').value : null,
        "isUniversityInstituteNotAvailableUMIS": this.studentForm.get('others').value,
        "instituteId": this.studentForm.get('instituteName').value != null ? Number(this.studentForm.get('instituteName').value) : null,
        "universityId": this.studentForm.get('universityName').value != null ? Number(this.studentForm.get('universityName').value) : null,
        "academicYearId": Number(this.studentForm.get('academicYear').value),
        "streamInfoId": Number(this.studentForm.get('stream').value),
        "courseTypesId": Number(this.studentForm.get('courseType').value),
        "courseCategorysId": Number(this.studentForm.get('CourseCategory').value),
        "courseId": Number(this.studentForm.get('Course').value),
        "modeOfStudyId": Number(this.studentForm.get('ModeofStudy').value),
        "mediumOfInstructionType": Number(this.studentForm.get('medium').value),
        "courseSpecializationId": Number(this.studentForm.get('BranchSpecialization').value),
        "name": this.studentForm.get('name').value,
        "genderId": Number(this.studentForm.get('gender').value),
        "mobileNo": this.studentForm.get('mobile').value,
        "emailId": this.studentForm.get('email').value,
        "stateId": Number(this.studentForm.get('state').value),
        "districtId": Number(this.studentForm.get('district').value),
        "aadhaarNo": aadhaarNumberOnly,
        "courseTiming": Number(this.studentForm.get('Shift').value),
        "dateOfBirth": this.studentForm.get('dob').value,
        "dateOfAdmission": this.studentForm.get('DateofAdmission').value,
        "nationalityId": Number(this.studentForm.get('nationality').value),
        "GrievanceSubmittedBy":1,
        "fatherName":this.studentForm.get('fatherName').value,
        "motherName":this.studentForm.get('motherName').value,

      }
      this.dataService.laptopSchemeisSave(payload).subscribe((res) => {
        if (res?.isSuccess) {
          this.showOtppopup = false;
          this.dialogRef.close(false);
          const dialogRef = this.dialog.open(LaptopSavepopupComponent, {
            autoFocus: false,
            disableClose: true,
            width: "0",
            height: "0",
            panelClass: "mat-dialog",
            data: {
              openKey: 1,
            }
          });
          dialogRef.afterClosed().subscribe((data) => {
            if (data) {

            }

          });

        } else {
          this.toaster.error(res?.htmlFormattedFailures);
        }
      })
    }
    else {
      this.submitted = true;
      this.studentForm.markAllAsTouched();
      this.toaster.error("Please required all field");

    }

  }
  onInput(event: any, regexPattern: any): void {
    this.inputFormatService.isNumericOrHyphenOrSpace(event, regexPattern);
  }


  emailPattern() {
    const emailCtrl = this.studentForm.get('email');
    const value = emailCtrl?.value;

    if (value) {
      emailCtrl.setValue(value.toLowerCase(), { emitEvent: false });
    }
  }


  toUpperUniversity() {
    const name = this.studentForm.get('otherUniversity')?.value || '';
    this.studentForm.get('otherUniversity')?.setValue(name.trim().toUpperCase());
  }

  toUpperInsititue() {
    const name = this.studentForm.get('otherInstitute')?.value || '';
    this.studentForm.get('otherInstitute')?.setValue(name.trim().toUpperCase());
  }

  toUpper() {
    const name = this.studentForm.get('name')?.value || '';
    this.studentForm.get('name')?.setValue(name.trim().toUpperCase());
  }

  toUpperMother()
  {
    const name = this.studentForm.get('motherName')?.value || '';
    this.studentForm.get('motherName')?.setValue(name.trim().toUpperCase());

  }

  toUpperFather()
  {
    const name = this.studentForm.get('fatherName')?.value || '';
    this.studentForm.get('fatherName')?.setValue(name.trim().toUpperCase());

  }




  // Function to allow only letters and spaces
  allowOnlyLetters(event: any) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ\s]/g, '');
  }

}




